export class ApplicationPath{

    static API_KEY: string = "cdmlkjeeuioptepelsddjkls"
    static HOST: string = "https://taichi.archemedia.eu/"
    static SERVER: string = ApplicationPath.HOST + "server/"

    static CRUD: string = ApplicationPath.SERVER + "crud/v1/api.php/"
    static SERVER_MAIN_SERVICE: string = ApplicationPath.SERVER + "service/mainService.php"
    static SERVER_UPLOAD_SERVICE: string = ApplicationPath.SERVER + "service/uploadService.php"

    //static JADE_BOIS_LOGO: string = ApplicationPath.SERVER + "assets/logo jade-bois.png"
    //static PROJECT_IMAGES: string = ApplicationPath.SERVER + "projectImages/"
}
